export const api = {
  viewReceiptsUrlFn: (companyId: string, includeReceiptDetails?: boolean) =>
    `POReceipt/Filter?companyId=${companyId}&includeReceiptDetails=${!!includeReceiptDetails}`,
  viewReceiptDeleteUrl: 'Receipt/Delete',
  viewReceiptUndeleteUrl: 'Receipt/Undelete',
  viewReceiptCompleteUrl: 'Receipt/Complete',
  viewReceiptCancelUrlFn: (receiptId: string) => `Receipt/${receiptId}/Cancel`,
  viewReceiptReopenUrl: 'Receipt/ReOpen',
  getInvoiceDataUrlFn: (companyId: string) => `Invoice/Filter?companyId=${companyId}`,
  getInvoiceUploadS3UrlFn: () => 'Invoice/S3UploadUrl',
  getReceiptUploadS3UrlFn: () => 'Receipt/S3UploadUrl',
  getScanInvoiceDataUrlFn: (companyId: number, uploadsOlderThan90Days?: boolean) =>
    `Invoice/Attach/Filter?companyId=${companyId}&uploadsOlderThan90Days=${uploadsOlderThan90Days}`,
  getScanReceiptDataUrlFn: (companyId: number) => `Receipt/Attach/Filter?companyId=${companyId}`,
  getScanManagerInvoiceRecords: 'Invoice/Attach/Filter',
  getScanManagerReceiptRecords: 'Receipt/Attach/Filter',
  uploadScanManagerInvoiceRecordFn: (companyId: number, id?: number) =>
    id
      ? `Invoice/Attach?companyId=${companyId}&invoiceId=${id}`
      : `Invoice/Attach?companyId=${companyId}`,
  deleteScanManagerInvoiceRecord: 'Invoice/Attach/Delete',
  checkInvoiceNumber: (invoiceId: string) => `Invoice/${invoiceId}/CheckDuplicateInvoiceNumber`,
  deleteScanManagerReceiptRecord: 'Receipt/Attach/Delete',
  uploadScanManagerReceiptRecordFn: (companyId: number, id?: number) =>
    id
      ? `Receipt/Attach?companyId=${companyId}&receiptId=${id}`
      : `Receipt/Attach?companyId=${companyId}`,
  poDetails: (poId: string) => `/PO/${poId}`,
  receiptDetails: (receivingReceiptId: string) => `Receipt/${receivingReceiptId}`,
  getReceiptDataUrlFn: (companyId: number) => `Receipt/Attach/Filter?companyId=${companyId}`,
  viewInvoicesUrlFn: (companyId: string) => `POInvoice/Filter?companyId=${companyId}`,
  isDuplicateApId: (poId: string) => `PO/${poId}/isDuplicateApId`,
  isDuplicateSupplierName: (poId: string) => `PO/${poId}/isDuplicateExternalSupplierName`,
  cancelInvoice: 'Invoice/Cancel',
  completeInvoice: 'Invoice/Complete',
  cancelReceipt: 'Receipt/Cancel',
  closePO: 'PO/Close',
  cancelPO: 'PO/Cancel',

  getReceiptDataUrlGenerator: (receivingReceiptId: number) => `Receipt/${receivingReceiptId}`,
  getInvoiceDataUrlGenerator: (receivingInvoiceId: number) => `Invoice/${receivingInvoiceId}`,
  addAttachmentsToInvoiceFn: (invoiceId: number) => `Invoice/${invoiceId}/Attach`,
  getInvoiceAttachments: (invoiceId: number) => `Invoice/${invoiceId}/Attach`,
  addAttachmentsToReceiptFn: (receiptId: number) => `Receipt/${receiptId}/Attach`,
  unAttachReceiptUrlFn: (receiptId: number, attachId: number) =>
    `Receipt/${receiptId}/UnAttach?attachId=${attachId}`,
  unAttachInvoiceUrlFn: (invoiceId: number, attachId: number) =>
    `Invoice/${invoiceId}/UnAttach?attachId=${attachId}`,
  changeInvoiceDocumentName: 'Invoice/Attach/Rename',
  changeReceiptDocumentName: 'Receipt/Attach/Rename',
  deleteAttachmentOfReceiptIdFn: (receiptId: number) =>
    `Receipt/Attach/Delete?receiptId=${receiptId}`,
  deleteAttachmentOfInvoiceIdFn: (invoiceId: number) =>
    `Invoice/Attach/Delete?invoiceId=${invoiceId}`,
  updateInvoice: (invoiceId: string) => `Invoice/${invoiceId}`,
  createReceiptWithAttachments: 'Receipt',
  linkInvoice: (receiptId: string) => `Receipt/${receiptId}/LinkInvoice`,
  unlinkInvoice: (receiptId: string) => `Receipt/${receiptId}/unlinkInvoice`,
  getVariance: (companyId: string) => `Variance/Filter?companyId=${companyId}`,
  actionRequiredInvoice: (overBudgetOnly?: boolean) =>
    `Invoice/FilterByActionRequired?overBudgetOnly=${overBudgetOnly}`,
  declineInvoice: 'Invoice/Decline',
  recallInvoice: 'Invoice/Recall',
  submitForApprovalInvoice: 'Invoice/SubmitForApproval',
  changeInvoicePoAssignment: (invoiceId?: number) => `Invoice/${invoiceId}/ChangePo`,
  changeReceiptPoAssignment: (receiptId?: number) => `Receipt/${receiptId}/ChangePo`,
  getReceiptNotes: 'Receipt/ItemNotes',
  getInvoiceLineItems: (invoiceId: string) => `Invoice/${invoiceId}/lineItems`,
  getPoGlMismatchLineItems: (poId: number) => `Po/${poId}/mismatchGlCodes`,
  companyInvoiceScans: 'Invoice/CompanyInvoiceScans',
  companyReceiptScans: 'Receipt/CompanyReceiptScans',
  getPoDocument: (poId: string) => `po/${poId}/documents`,
  glPeriod: (companyId: string) => `GLCode/GlPeriods?companyId=${companyId}`,
  glCodesBudget: (companyId: string, glPeriodId?: number) =>
    `GLCode/Filter?glPeriodId=${glPeriodId}&companyId=${companyId}`,
  getActualizedAmount: (glCodeId: number, glPeriodId: number) =>
    `GLCode/${glCodeId}/SpentAmtTransactionLog?glPeriodId=${glPeriodId}`,
  getMultiPeriodAllocation: (poId: string) => `PO/${poId}/MultiPeriodAllocations`,
  getGlCodeSummary: (poId: string) => `PO/${poId}/GlCodeSummary`,
  approveInvoice: 'Invoice/Approve',
  getHoldAmount: (glCodeId: number, glPeriodId: number) =>
    `GLCode/${glCodeId}/HoldAmtTransactionLog?glPeriodId=${glPeriodId}`,
  getCommittedAmount: (glCodeId: number, glPeriodId: number) =>
    `GLCode/${glCodeId}/CommittedAmtTransactionLog?glPeriodId=${glPeriodId}`,
  updateReceipt: (receiptId: string) => `Receipt/${receiptId}`,
  glCodePeriodBudget: (companyId: string, glPeriodId?: number) =>
    `GLCode/GLBudgetsByPeriod?glPeriodId=${glPeriodId}&companyId=${companyId}`,
  glCodesBudgetByYear: (companyId: string, fiscalYear?: number) =>
    `GLCode/GlBudgetsbyyear?fiscalYear=${fiscalYear}&companyId=${companyId}`,
  glCodeDepartment: (companyId: string) => `GLCode/Departments?companyId=${companyId}`,
  undeleteGLCode: (companyId: string) => `GLCode/UnDelete?companyId=${companyId}`,
  journalEntry: (glCdId: string, companyId: string) =>
    `GLCode/${glCdId}/JournalEntry?companyId=${companyId}`,
  saveGLCode: (companyId: string) => `GLCode?companyId=${companyId}`,
  deleteGLCode: (companyId: string) => `GLCode/Delete?companyId=${companyId}`,
  deleteDepartment: (companyId: string) => `Department/Delete?companyId=${companyId}`,
  GLPeriodTransaction: (glPeriodId: number, glCdId?: number) =>
    `GLPeriod/${glPeriodId}/TransactionLog?glCdId=${glCdId ?? ''}`,
  department: (companyId: string) => `Department?companyId=${companyId}`,
  addDepartment: (companyId: number) => `Department?companyId=${companyId}`,
  client: (companyId: string) => `Client?companyId=${companyId}`,
  copyDepartment: (companyId: number, departmentId: number) =>
    `Department/${departmentId}/Duplicate?companyId=${companyId}`,
  copyFromDepartment: (companyId: string, departmentId: number) =>
    `Department/CopyFrom?sourceDepartmentId=${departmentId}&companyId=${companyId}`,
  updateDepartment: (departmentId: number, companyId?: string) =>
    `Department/${departmentId}?companyId=${companyId}`,
  getAllGlCode: (companyId: string) => `GLCode/All?companyId=${companyId}`,
  bulkUpdateMember: (companyId: string) => `Department/BulkUpdateClients?companyId=${companyId}`,
  bulkUpdateGLCode: (companyId: string) => `Department/BulkUpdateGlCodes?companyId=${companyId}`,
  getInvoiceMultiPeriodAllocation: (invoiceId: number) =>
    `Invoice/${invoiceId}/MultiPeriodAllocations`,
  getNearestPeriod: (invoiceId: number) => `Invoice/${invoiceId}/NearestPoPeriod`,
  getInvoiceGlBudgetSummary: (invoiceId: string) => `Invoice/${invoiceId}/RemainingBudgets`,
  getGlMasks: 'GLMask/GetGlMasks',
  getInvalidGLCodes: 'GLMask/GetInvalidGlCodes',
  saveGLCodeFormats: 'GLMask/SaveGLMasks',
  updateGLCodeAttributes: 'GLCode/GLAttributes',
  closeGLPeriod: 'GLPeriod/Close',
  getFiscalYears: (propertyId: number, allProperties: boolean) =>
    `GlTool/GlExportFiscalYears?companyId=${propertyId}&allProperties=${allProperties}`,
  getAllFiscalYears: () => `glperiod/GetFiscalYears`,
  getImportsS3Url: (fileName?: string) => 'GlTool/S3UploadUrl?fileName=' + fileName,
  budgetImport: 'GlTool/BudgetImport',
  lastImport: (companyId: string) => 'GLTool/LastImportDetails/' + companyId,
  importExceptions: (importId: number, fileType: string) =>
    `GLTool/ImportExceptionFile?importId=${importId}&fileType=${fileType}`,
  exportGLBudgets: 'GLCode/ExportGLBudgets',
  glCodeDepartments: (companyId: string) => `Glcode/GlCodeDepartments?companyId=${companyId}`,
  getAccrualReport: (companyId: string, glPeriodId: number) =>
    `Report/AccrualReport?companyId=${companyId}&glPeriodId=${glPeriodId}`,
  getManagementCompanies: 'client/GetManagementCompanies',
  convertAllocation: (invoiceId: number) => `Invoice/${invoiceId}/ConvertAllocation`,
  getCompanyAttributes: (companyId: number) => `Company/${companyId}/attributes`,
  createCalendarYear: () => `/GLPeriod/CalendarYear`,
  createNoNCalendarYear: `/GLPeriod/NoNCalendarYear`,
  deleteGLPeriod: `/GLPeriod/Delete`,
  reassignCompany: () => `/Invoice/Attach/Reassign`,
  runOcrScan: () => `/Invoice/SubmitForOcr`,
  deleteOcrInvoiceAttachments: () => `/Invoice/DeleteOcrRecords`,
  mergeAttachment: () => `/Invoice/MergeAttachment`,
  getInvoiceMatches: (InvoiceNumber: string, CompanyId: string) =>
    `/Invoice/GetInvoiceMatches?InvoiceNumber=${InvoiceNumber}&CompanyId=${CompanyId}`,
  getOcrCount: (companyId: string, uploadsOlderThan90Days?: boolean) =>
    `/Invoice/GetOcrRecordsCount?companyId=${companyId}&uploadsOlderThan90Days=${uploadsOlderThan90Days}`,
  unDeleteAttachments: () => `/Invoice/UnDeleteAttachments`,
  getPoMatches: (poNumber: string, companyId: string) =>
    `/PO/GetPoMatches?PoNumber=${poNumber}&CompanyId=${companyId}`,

  reviewDocument: () => `/Invoice/ReviewDocument`,
  reviewPo: () => '/Invoice/ReviewPo',
  getOcrFailedMessage: (attachmentId: number) =>
    `/Invoice/GetOcrFailureResponse?attachmentId=${attachmentId}`,
  checkIsExistingOcrDocument: () => `Invoice/CheckIsExistingOcrDocument`,
  getAllSuppliers: (attachmentId: number) => `/Invoice/Attach/${attachmentId}/Suppliers`,
  createOcrDocument: (attachmentId: number) => `Invoice/Attach/${attachmentId}/CreateOcrInvoice`,
  getOcrResponse: (attachmentId: number) => `Invoice/Attach/${attachmentId}/GetOcrResponse`,
};
